module.exports = __webpack_public_path__ + "img/dna-white.5ba84f5b.png";